import styled from "styled-components";

export const EVoucherAddToCusWidgetStyled = styled.div``;
